import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { ComentarioContact } from 'src/app/hojas-call-center/GestionPeticiones/detalle-peticion/detalle-peticion.component';
import { DetallePetcicion } from 'src/app/hojas-call-center/GestionPeticiones/detalle-peticion/DetallePetcicion';
import { PeticionWeb,PeticionWebNew,PeticionOutbound, PeticionWebRauda } from 'src/app/hojas-call-center/models/PeticionWeb';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GestionPeticionService
{
  constructor(private http: HttpClient,private msalService:MsalService){}

  public getPeticionAlp(token:string, fInicio:string,fFin:string, estado:string,tipoGestion:string,mFiltros: Map<string, string>){
    let url:string = environment.hojaWSBase + "/HojasPendienteAlphabet"

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };

    let arrParams =
      {
        "parameters":
          [
            [{
              campo:"esponsor",
              operacion:"=",
              valor:tipoGestion
            }],
            [{
              campo:"created",
              operacion:">=",
              valor:fInicio
            }],
            [{
              campo:"created",
              operacion:"<=",
              valor:fFin
            }]
          ],
        select:
          [
            "id as cld",
            "id_reparacion as id_reparación",
            "created",
            "trim(num_siniestro) as número_siniestro",
            "trim(matricula) as matrícula",
            "TRIM(COALESCE(elemento_afectado, '')) as elemento_afectado",
            "TRIM(COALESCE(esponsor, '')) as esponsor",
            "TRIM(COALESCE(nombre_cliente, '')) as nombre_cliente",
            "TRIM(COALESCE(marca, '')) as marca",
            "TRIM(COALESCE(modelo, '')) as modelo",
            "TRIM(COALESCE(version_vehiculo, '')) as versión_vehículo",
            "TRIM(COALESCE(descripcion_danos_mecanicos, '')) as decripción_daños",
            "TRIM(COALESCE(nombre_conductor, '')) as nombre_conductor",
            "TRIM(COALESCE(telefono, '')) as teléfono",
            "COALESCE(perito, false) as perito",
            "TRIM(COALESCE(modalidad, '')) as modalidad",
            "COALESCE(vehiculo_sustitucion, false) as vehículo_sustitución",
            "COALESCE(dias_vehiculo_sustitucion, '') as días_vehículos_sustitución",
            "COALESCE(penalizacion, false) as penalización",
            "COALESCE(culpa, 0) as culpa",
            "TRIM(COALESCE(observaciones, '')) as observaciones",
            "COALESCE(foto_peritacion, false) as foto_peritación",
            "COALESCE(estado_contact, 0) as estado_contact"
          ],
        orden: [["created","DESC"]]
      };

    if(estado!=="9")
      arrParams.parameters.push
      (
        [{
          campo:"estado_contact",
          operacion:"=",
          valor:estado+""
        }]
      );

    if(mFiltros.has("siniestro"))
    {
      arrParams.parameters.push
      (
        [{
          campo:"num_siniestro",
          operacion:"LIKE",
          valor:'%'+mFiltros.get("codigo_cita")!.toString()+'%'
        }]
      );
    }
    if(mFiltros.has("matricula"))
    {
      arrParams.parameters.push
      (
        [{
          campo:"matricula",
          operacion:"LIKE",
          valor:'%'+mFiltros.get("matricula")!.toString()+'%'
        }]
      );
    }
    if(mFiltros.has("telefono"))
    {
      arrParams.parameters.push
      (
        [{
          campo:"telefono",
          operacion:"LIKE",
          valor:'%'+mFiltros.get("telefono")!.toString()+'%'
        }]
      );
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          },
        })
    });
  }
  public getPeticionesWebNew(token:string, fInicio:string,fFin:string, estado:number,tipoGestion:string,mFiltros: Map<string, string>):Promise<PeticionWebNew[]>
  {
    let url:string = environment.callCenterWSBase + "/WebRalarsaCitas/"

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
      .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };

    let arrParams =
    {
      "parameters":
      [
        [{
          campo:"tipo",
          operacion:"=",
          valor:tipoGestion
        }],
         [{
          campo:"creador",
          operacion:"<>",
          valor:"RAUDA"
        }],
        [{
          campo:"created",
          operacion:">=",
          valor:fInicio
        }],
        [{
          campo:"created",
          operacion:"<=",
          valor:fFin
        }]
      ],
      select:
      [
        "id",
        "taller",
        "damage_area as área_dañada",
        "es_te_llamamos as thanks",
        "tipo_vehiculo as tipo_vehículo",
        "codigo_cita as código_cita",
        "fecha_cita as fecha_hora_cita",
        "other_damage_area as otra_area_dañada",
        "damage_side as lugar_dañado",
        "cia as aseguradora",
        "to_char(created, 'DD/MM/YYYY HH24:mi') as fecha_creacion",
        "COALESCE(to_char(modified, 'DD/MM/YYYY HH24:mi'), '') as fecha_modificacion",
        "nombre",
        "matricula as matrícula",
        "modelo",
        "damage_type as tipo_daño",
        "telefono",
        "email as correo",
        "luna_afectada as tipo_cristal",
        "tipo",
        "estado_contact as estado",
        "es_persona_riesgo as mayor_de_edad",
        "marca",
        "COALESCE(lead, '') as origen",
        "COALESCE(glass_treatment,'') as oper_cristal",
        "ai_confidence as precisión_ia"
      ],
      orden: [["created","ASC"]]
    };
    //VAMOS COMPROBANDO LOS FILTROS DEL USUARIO
    //ESTADO
    if(estado!=9)
      arrParams.parameters.push
      (
        [{
          campo:"estado_contact",
          operacion:"=",
          valor:estado+""
        }]
      );

      if(mFiltros.has("codigo_cita"))
      {
        arrParams.parameters.push
        (
          [{
            campo:"codigo_cita",
            operacion:"=",
            valor:mFiltros.get("codigo_cita")!.toString()
          }]
        );
      }
      if(mFiltros.has("matricula"))
      {
        arrParams.parameters.push
        (
          [{
            campo:"matricula",
            operacion:"=",
            valor:mFiltros.get("matricula")!.toString()
          }]
        );
      }
      if(mFiltros.has("telefono"))
      {
        arrParams.parameters.push
        (
          [{
            campo:"telefono",
            operacion:"=",
            valor:mFiltros.get("telefono")!.toString()
          }]
        );
      }
      if(mFiltros.has("ia"))
      {
        switch(mFiltros.get("ia"))
        {
          //SOLO INCLUIR casos con IA
          case "S":
          case "s":
          arrParams.parameters.push
          (
            [{
              campo:"ai_confidence",
              operacion:"!=",
              valor:""
            }]
          );
            break;
          //EXCLUIR CASOS CON IA
          case "N":
          case "n":
            arrParams.parameters.push
          (
            [{
              campo:"ai_confidence",
              operacion:"=",
              valor:""
            }]
          );
            break;
          //No se filtra por ia
          default:break;
        }
      }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        },
      })
    });
  }

  // Case rauda
  public getPeticionesRauda(token:string, fInicio:string,fFin:string, estado:number,mFiltros: Map<string, string>):Promise<PeticionWebRauda[]>
  {
    let url:string = environment.callCenterWSBase + "/WebRalarsaCitas/"

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
      .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };

    let arrParams =
    {
      "parameters":
      [
        [{
          campo:"tipo",
          operacion:"=",
          valor:"3"
        }],
         [{
          campo:"creador",
          operacion:"=",
          valor:"RAUDA"
        }],
        [{
          campo:"created",
          operacion:">=",
          valor:fInicio
        }],
        [{
          campo:"created",
          operacion:"<=",
          valor:fFin
        }]
      ],
      select:
      [
        "id",
        "taller",
        "damage_area as area_dañada",
        "tipo_vehiculo as tipo_vehículo",
        "codigo_cita as código_cita",
        "fecha_cita as fecha_hora_cita",
        "other_damage_area as otra_area_dañada",
        "damage_side as lugar_dañado",
        "cia as aseguradora",
        "to_char(created, 'DD/MM/YYYY HH24:mi') as fecha_creacion",
        "COALESCE(to_char(modified, 'DD/MM/YYYY HH24:mi'), '') as fecha_modificacion",
        "nombre",
        "matricula as matrícula",
        "modelo",
        "damage_type as tipo_daño",
        "telefono",
        "email as correo",
        "luna_afectada as tipo_cristal",
        "tipo",
        "estado_contact as estado",
        "marca",
        "COALESCE(lead, '') as origen",
        "creador as usuario_creador"
      ],
      orden: [["created","ASC"]]
    };
    //VAMOS COMPROBANDO LOS FILTROS DEL USUARIO
    //ESTADO
    if(estado!=9)
      arrParams.parameters.push
      (
        [{
          campo:"estado_contact",
          operacion:"=",
          valor:estado+""
        }]
      );

      if(mFiltros.has("codigo_cita"))
      {
        arrParams.parameters.push
        (
          [{
            campo:"codigo_cita",
            operacion:"=",
            valor:mFiltros.get("codigo_cita")!.toString()
          }]
        );
      }
      if(mFiltros.has("matricula"))
      {
        arrParams.parameters.push
        (
          [{
            campo:"matricula",
            operacion:"=",
            valor:mFiltros.get("matricula")!.toString()
          }]
        );
      }
      if(mFiltros.has("telefono"))
      {
        arrParams.parameters.push
        (
          [{
            campo:"telefono",
            operacion:"=",
            valor:mFiltros.get("telefono")!.toString()
          }]
        );
      }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        },
      })
    });
  }

  public getPeticionesWebNewElse(token:string, fInicio:string,fFin:string, estado:number,tipoGestion:string,mFiltros: Map<string, string>):Promise<any[]>
  {
    let url:string = environment.callCenterWSBase + "/WebRalarsaServicios"

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };
    //Si el tipo de gestión es -1, no se filtra por tipo
    let arrParams =
      {
        "parameters":
          [
            (tipoGestion !== "-1" ? 
            [{
              campo:"tipo",
              operacion:"=",
              valor:tipoGestion
            }]
            : []),
            [{
              campo:"created",
              operacion:">=",
              valor:fInicio
            }],
            [{
              campo:"created",
              operacion:"<=",
              valor:fFin
            }]
          ],
        select:
          [
            "id",
            "to_char(created, 'DD/MM/YYYY HH24:mi') as fecha_creacion",
            "COALESCE(to_char(modified, 'DD/MM/YYYY HH24:mi'), '') as fecha_modificacion",
            "nombre",
            "matricula as matrícula",
            "telefono",
            "email as correo",
            "acepta_politicas as politicas",
            "metodo_contacto",
            "cpost as codigo_postal",
            "tipo_vehiculo",
            "modelo",
            "damage_type as tipo_daño",
            "SUBSTRING(comentario,1,30) as comentario",
            "campana as tipo_campaña",
            "motivo_contacto",
            "tipo",
            "glass_type as tipo_cristal",
            "estado_contact as estado",
            "slug as tipo_servicio",
            "lead as origen",
            "titulocampaya as titulo_campaña",
            "ipuser as ip_usuario",
            "newsletter as condiciones_noticias"
          ],
        orden: [["created","DESC"]]
      };
    //VAMOS COMPROBANDO LOS FILTROS DEL USUARIO
    //ESTADO
    if(estado!=9)
      arrParams.parameters.push
      (
        [{
          campo:"estado_contact",
          operacion:"=",
          valor:estado+""
        }]
      );

    if(mFiltros.has("codigo_cita"))
    {
      arrParams.parameters.push
      (
        [{
          campo:"codigo_cita",
          operacion:"=",
          valor:mFiltros.get("codigo_cita")!.toString()
        }]
      );
    }
    if(mFiltros.has("matricula"))
    {
      arrParams.parameters.push
      (
        [{
          campo:"matricula",
          operacion:"=",
          valor:mFiltros.get("matricula")!.toString()
        }]
      );
    }
    if(mFiltros.has("telefono"))
    {
      arrParams.parameters.push
      (
        [{
          campo:"telefono",
          operacion:"=",
          valor:mFiltros.get("telefono")!.toString()
        }]
      );
    }
    if(mFiltros.has("ia"))
    {
      switch(mFiltros.get("ia"))
      {
        //SOLO INCLUIR casos con IA
        case "S":
        case "s":
          arrParams.parameters.push
          (
            [{
              campo:"ai_confidence",
              operacion:"!=",
              valor:""
            }]
          );
          break;
        //EXCLUIR CASOS CON IA
        case "N":
        case "n":
          arrParams.parameters.push
          (
            [{
              campo:"ai_confidence",
              operacion:"=",
              valor:""
            }]
          );
          break;
        //No se filtra por ia
        default:break;
      }
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          },
        })
    });
  }
  public getPeticionesOutbound(token:string, fInicio:string,fFin:string, estado:number):Promise<PeticionOutbound[]>
  {
    let url:string = environment.callCenterWSBase + "/Outboundgi"

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
      .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };
    let arrParams =
    {
      parameters:
      [
        [{
          campo:"created",
          operacion:">=",
          valor:fInicio
        }],
        [{
          campo:"created",
          operacion:"<=",
          valor:fFin
        }]
      ],
      select:
      [
        "id",
        "nombre",
        "origen",
        "matricula",
        "marca",
        "modelo",
        "luna_afectada",
        "telefono_contacto",
        "estado",
        "to_char(created, 'DD/MM/YYYY HH24:mi') as fecha_creacion",
        "modified as fecha_modificacion"
      ],
      orden: [["created","ASC"]]
    };
    if(estado < 9 )
    {
      arrParams.parameters
      .push
      (
        [{
          campo:"estado",
          operacion:"=",
          valor:estado+""
        }]
      )
    }
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          reject(err);
        },
      })
    });
  }

  public getSegurCaixa(token:string, fInicio:string,fFin:string, estado:number,mFiltros: Map<string, string>):Promise<PeticionWebNew[]>
  {
    let url: string  = environment.callCenterWSBase + "/SegurCaixaServicios";

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };

    let arrParams =
      {
        "parameters":
          [
            [{
              campo:"created",
              operacion:">=",
              valor:fInicio
            }],
            [{
              campo:"created",
              operacion:"<=",
              valor:fFin
            }]
          ],
        select:
          [
            "id",
            "expediente",
            "matricula as matrícula",
            "poliza as póliza",
            "descripcion as descripción",
            "telefono as teléfono",
            "estado_contact as estado",
            "to_char(created, 'DD/MM/YYYY HH24:mi') as fecha_creación"
          ],
        orden: [["created","ASC"]]
      };

    if(estado!=9)
      arrParams.parameters.push
      (
        [{
          campo:"estado_contact",
          operacion:"=",
          valor:estado+""
        }]
      );

    if(mFiltros.has("matricula"))
    {
      arrParams.parameters.push
      (
        [{
          campo:"matricula",
          operacion:"=",
          valor:mFiltros.get("matricula")!.toString()
        }]
      );
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }

  public getLineaDirecta(token:string, fInicio:string,fFin:string, estado:number,mFiltros: Map<string, string>):Promise<PeticionWebNew[]>
  {
    let url: string  = environment.callCenterWSBase + "/LineaDirecta";

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };

    let arrParams =
      {
        "parameters":
          [
            [{
              campo:"created",
              operacion:">=",
              valor:fInicio
            }],
            [{
              campo:"created",
              operacion:"<=",
              valor:fFin
            }]
          ],
        select:
          [
            "id",
            "nomcli",
            "dni",
            "poblacion as población",
            "matricula as matrícula",
            "siniestro",
            "poliza as póliza",
            "to_char(fecsin, 'DD/MM/YYYY HH24:mi') as fec_sin",
            "marca",
            "color",
            "anyo as año",
            "descripcion as descripción",
            "par1 as estado",
            "usuario as user",
            "empresa as taller",
            "hoja"
          ],
        orden: [["siniestro","DESC"]]
      };

    if(estado!=9)
      arrParams.parameters.push
      (
        [{
          campo:"par1",
          operacion:"=",
          valor:estado+""
        }]
      );

    if(mFiltros.has("matricula"))
    {
      arrParams.parameters.push
      (
        [{
          campo:"matricula",
          operacion:"=",
          valor:mFiltros.get("matricula")!.toString()
        }]
      );
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }

  public getCaser(token:string, fInicio:string,fFin:string, estado:number,mFiltros: Map<string, string>):Promise<PeticionWebNew[]>
  {
    let url: string  = environment.callCenterWSBase + "/Caser";

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };

    let arrParams =
      {
        "parameters":
          [
            [{
              campo:"created",
              operacion:">=",
              valor:fInicio
            }],
            [{
              campo:"created",
              operacion:"<=",
              valor:fFin
            }]
          ],
        select:
          [
            "id",
            "fecasig as fecha_petición",
            "nomcli",
            "dni",
            "direccion as dirección",
            "telefono as teléfono",
            "poblacion as población",
            "codpos as codigo_postal",
            "provincia as provincia",
            "matricula as matrícula",
            "siniestro as siniestro",
            "poliza as póliza",
            "expediente as expediente",
            "to_char(fecsin, 'DD/MM/YYYY HH24:mi') as fec_sin",
            "marca",
            "modelo",
            "color",
            "anyo as año",
            "descripcion as descripción",
            "par1 as estado",
            "usuario as user",
            "empresa as taller",
            "hoja"
          ],
        orden: [["siniestro","DESC"]]
      };

    if(estado!=9)
      arrParams.parameters.push
      (
        [{
          campo:"par1",
          operacion:"=",
          valor:estado+""
        }]
      );

    if(mFiltros.has("matricula"))
    {
      arrParams.parameters.push
      (
        [{
          campo:"matricula",
          operacion:"=",
          valor:mFiltros.get("matricula")!.toString()
        }]
      );
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }
  public getPeticionForId(token:string, id:number, gestion: string, subgestion?:number)
  {
    let url:string = "";
    let id_pet:string = "id";
    switch (gestion) {
      case "outbound":
        url = environment.callCenterWSBase + "/Outboundgi";
        break;
      case "gestionWebNew":
        if (subgestion == 3){
          url = environment.callCenterWSBase + "/WebRalarsaCitas";
        }else{
          url = environment.callCenterWSBase + "/WebRalarsaServicios";
        }
        break;
      case "gestionWeb":
        url = environment.hojaWSBase + "/GestionWeb"
        break;
      case "segurCaixa":
        url = environment.callCenterWSBase + "/SegurCaixaServicios";
        break;
      case "lineaDirecta":
        url = environment.callCenterWSBase + "/LineaDirecta";
        break;
      case "TUVOZ":
        url = environment.callCenterWSBase + "/Coris";
        id_pet = "pet";
        break;
      case "REPARABRISAS RLS":
        url = environment.rlsWSBase + "/ServCorredor";
        break;
      case "rauda":
        url = environment.callCenterWSBase + "/WebRalarsaCitas";
        break;
    }

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };
    let arrParams =
      {
        "parameters":
          [
            [{
              campo:id_pet,
              operacion:"=",
              valor:id
            }]
          ]
      };
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }

  public getDetalleAlp(token:string, id:number){
    let url:string = environment.hojaWSBase + "/HojasPendienteAlphabet/detalleAlp";

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,""+id+"",httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }
  public getPeticionesWeb(token:string, fInicio:string,fFin:string, estado:number,tipoGestion:string)
  {
    let url:string = environment.hojaWSBase + "/GestionWeb"
    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };
    let arrParams =
      {
        parameters:
          [
            [{
              campo:"tipo",
              operacion:"LIKE",
              valor:tipoGestion+"%"
            }],
            [{
              campo:"fecha",
              operacion:">=",
              valor:fInicio
            }],
            [{
              campo:"fecha",
              operacion:"<=",
              valor:fFin
            }]
          ],
        select:
          [
            "id",
            "tipo",
            "nomcli",
            "telefono as teléfono",
            "to_char(fecha, 'DD/MM/YYYY') as fecha",
            "provincia",
            "taller",
            "marca",
            "modelo",
            "puertas",
            "lamina as lámina",
            "email",
            "descr as descripción",
            "obser",
            "par1 as estado",
            "usuario as user",
            "empresa",
            "hoja",
            "matricula as matrícula",
            "siniestro",
            "servicio"
          ],
        orden: [["created","DESC"]]
      };
    if(estado != 9 )
    {
      arrParams.parameters
        .push
        (
          [{
            campo:"par1",
            operacion:"=",
            valor:estado+""
          }]
        )
    }
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }

  public getLineasComentario(token:string, id:string, tipo: string):Promise<ComentarioContact[]>
  {
    let url:string = ""
    let id_pet = "id";
    if (tipo == "segurCaixa"){
      url = environment.callCenterWSBase + "/SegurCaixaServLin"

    }else if(tipo == "TUVOZ"){
      url = environment.callCenterWSBase + "/CorisLin/"
      id_pet = "pet";
    }
    else if(tipo == "REPARABRISAS RLS"){
      url = environment.rlsWSBase + "/ServCorredorLin/"
    }
    else if(tipo == "alphabet" || tipo == "drivalia"){
      url = environment.hojaWSBase + "/HojasAlphabetLin/"
      id_pet = "id_hoja";
    }
    else{
      url = environment.hojaWSBase + "/GestionWebLin/"
    }

    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
      .set('Authorization', 'Bearer ' + token ),
      params: new HttpParams({})
    };
    let arrParams =
    {
      "parameters":
      [
        [{
          campo:id_pet,
          operacion:"=",
          valor:id+""
        }]
      ],
      select:
      [
        "linea",
        "obser",
        "usuario",
        "to_char(created, 'DD/MM/YYYY HH24:mi') as created"
      ],
      orden: [["linea","DESC"]]
    };
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          reject(err);
        },
      });
    });
  }
  //Agrega una linea de comentario en el detalle de la peticion
  public InsertarLineaComentario(token:string,idPeticion:number, comentario:ComentarioContact, tipo: string)
  {
    let url:string = "";
    if (tipo == "segurCaixa"){
      url = environment.callCenterWSBase + "/SegurCaixaServLin";
    }else if(tipo == "REPARABRISAS RLS" || tipo == "CORREDORES"){
      url = environment.rlsWSBase + "/ServCorredorLin/"
    }
    else{
      url = environment.hojaWSBase + "/GestionWebLin/";
    }
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
      .set('Authorization', 'Bearer ' + token ),
      params: new HttpParams({})
    };
    let arrParams =
    [{
      id:idPeticion,
      linea:comentario.linea,
      obser:comentario.obser,
      usuario:comentario.usuario
    }];
    return new Promise<any>((resolve, reject) =>
    {
      this.http.put(url,arrParams,httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          reject(err);
        },
      })
    });
  }


  public insertarLineaCoris(token:string,idPeticion:number, comentario:ComentarioContact){
    let url:string = environment.callCenterWSBase + "/CorisLin/";
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
        .set('Authorization', 'Bearer ' + token ),
      params: new HttpParams({})
    };
    let arrParams =
      [{
        pet:idPeticion.toString(),
        linea:comentario.linea,
        obser:comentario.obser,
        usuario:comentario.usuario
      }];
    return new Promise<any>((resolve, reject) =>
    {
      this.http.put(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }

  public insertarLineaAlphabet(token:string,idPeticion:number, comentario:ComentarioContact){
    let url:string = environment.hojaWSBase + "/HojasAlphabetLin/";
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
        .set('Authorization', 'Bearer ' + token ),
      params: new HttpParams({})
    };
    let arrParams =
      [{
        id_hoja:idPeticion.toString(),
        linea:comentario.linea,
        obser:comentario.obser,
        usuario:comentario.usuario
      }];
    return new Promise<any>((resolve, reject) =>
    {
      this.http.put(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }
  public UpdateEstadoWeb(token: string, tipo: string, param: any, subtipo?: number){
    let url:string = "";
    switch (tipo)
    {
      case "outbound":
        url = environment.callCenterWSBase + "/Outboundgi/update";
        break;
      case "gestionWebNew":
        if (subtipo == 3){
          url = environment.callCenterWSBase + "/WebRalarsaCitas/update";
        }else{
          url = environment.callCenterWSBase + "/WebRalarsaServicios/update";
        }
        break;
      case "gestionWeb":
        url = environment.hojaWSBase + "/GestionWeb/update";
        break;
      case "segurCaixa":
        url = environment.callCenterWSBase + "/SegurCaixaServicios/update";
        break;
      case "TUVOZ":
        url = environment.callCenterWSBase + "/Coris/update";
        break;
      case "REPARABRISAS RLS":
        url = environment.rlsWSBase + "/ServCorredor/update";
        break;
      case "alphabet":
      case "drivalia":
        url = environment.hojaWSBase + "/HojasPendienteAlphabet/update";
        break;
      case "rauda":
        url = environment.callCenterWSBase + "/WebRalarsaCitas/update";
        break;
    }

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Headers', 'Content-Type');
    options = options.set('Authorization', 'Bearer ' + token);

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    // Problema
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,param,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public saveEmailsChat(token: string){
    return Promise.resolve(true);
    let url = environment.callCenterWSBase + "/CorreosExternos/getChatBot";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Headers', 'Content-Type');
    options = options.set('Authorization', 'Bearer ' + token);

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.get(url,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }
  public saveEmailsMapfre(token: string, user: string){
    let url = environment.callCenterWSBase + "/CorreosExternos/getMapfre";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Headers', 'Content-Type');
    options = options.set('Authorization', 'Bearer ' + token);

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,'"'+user+'"',httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public saveEmailsSegu(token: string, user: string){
    let url = environment.callCenterWSBase + "/CorreosExternos/getSegurCaixa";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Headers', 'Content-Type');
    options = options.set('Authorization', 'Bearer ' + token);

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,'"'+user+'"',httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public saveEmailsTuVoz(token: string, user: string){
    let url = environment.callCenterWSBase + "/CorreosExternos/getTuVoz";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Headers', 'Content-Type');
    options = options.set('Authorization', 'Bearer ' + token);

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,'"'+user+'"',httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }
  public saveEmailsLineaDirecta(token: string, user: string){
    let url = environment.callCenterWSBase + "/CorreosExternos/getLinDirecta";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Headers', 'Content-Type');
    options = options.set('Authorization', 'Bearer ' + token);

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,'"'+user+'"',httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }
}
